import { useState } from "react";
import { useTheme } from "../../../theme";
import { BRAND_COLORS } from "../../../theme/colors.js";
import { SOCIALS } from "../../../data/socials.js";

export default function MobileNav({ onShowReel }) {
  const t = useTheme();
  const [open, setOpen] = useState(false);
  const links = ["Work", "About", "Contact", "Careers"];

  return (
    <div className="mobile-nav-wrap">
      {/* Hamburger button */}
      <button
        onClick={() => setOpen(!open)}
        aria-label="Menu"
        style={{
          width: 44, height: 44, borderRadius: 10,
          border: "1px solid " + t.borderStrong,
          background: open ? t.borderStrong : t.surfaceHover,
          display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
          gap: open ? 0 : 5, cursor: "pointer", transition: "all 0.3s ease",
          position: "relative", zIndex: 110,
        }}
      >
        <span style={{
          display: "block", width: 18, height: 1.5, borderRadius: 1,
          background: open ? BRAND_COLORS.cyan : t.textMid,
          transition: "all 0.3s ease",
          transform: open ? "rotate(45deg) translateY(0)" : "rotate(0) translateY(0)",
          position: open ? "absolute" : "relative",
        }} />
        {!open && <span style={{
          display: "block", width: 12, height: 1.5, borderRadius: 1,
          background: t.textLow, transition: "all 0.3s ease",
        }} />}
        <span style={{
          display: "block", width: 18, height: 1.5, borderRadius: 1,
          background: open ? BRAND_COLORS.cyan : t.textMid,
          transition: "all 0.3s ease",
          transform: open ? "rotate(-45deg) translateY(0)" : "rotate(0) translateY(0)",
          position: open ? "absolute" : "relative",
        }} />
      </button>

      {/* Overlay */}
      {open && <div
        onClick={() => setOpen(false)}
        style={{
          position: "fixed", inset: 0, zIndex: 99,
          background: t.overlayBg,
          backdropFilter: "blur(20px)",
          animation: "fadeIn 0.3s ease",
        }}
      />}

      {/* Slide-down menu */}
      <div style={{
        position: "fixed", top: 0, left: 0, right: 0,
        zIndex: 105,
        transform: open ? "translateY(0)" : "translateY(-110%)",
        opacity: open ? 1 : 0,
        transition: "all 0.4s cubic-bezier(0.16, 1, 0.3, 1)",
        background: t.mode === "dark" ? "rgba(10,10,15,0.97)" : "rgba(245,243,238,0.97)",
        borderBottom: `1px solid ${BRAND_COLORS.cyan}22`,
        padding: "90px 28px 36px",
        display: "flex", flexDirection: "column", gap: 0,
      }}>
        {links.map((item, i) => (
          <a
            key={item}
            href={item === "Careers" ? "/careers" : `#${item.toLowerCase()}`}
            onClick={() => setOpen(false)}
            style={{
              color: t.textMid, textDecoration: "none",
              fontSize: 22, fontWeight: 600, letterSpacing: 1,
              padding: "18px 0",
              borderBottom: "1px solid " + t.borderSubtle,
              transition: "all 0.3s ease",
              display: "flex", alignItems: "center", justifyContent: "space-between",
              animation: `fadeUp 0.4s ease ${i * 0.06}s both`,
            }}
          >
            {item}
            <span style={{ fontSize: 12, color: t.textFaint, fontFamily: "'DM Mono', monospace" }}>0{i + 1}</span>
          </a>
        ))}

        {/* Social links in mobile menu */}
        <div style={{
          display: "flex", gap: 16, justifyContent: "center", marginTop: 24, paddingTop: 20,
          borderTop: "1px solid " + t.borderSubtle,
          animation: `fadeUp 0.4s ease ${(links.length + 1) * 0.06}s both`,
        }}>
          {SOCIALS.map((s) => (
            <a key={s.name} href={s.href} target="_blank" rel="noopener noreferrer"
              style={{
                width: 40, height: 40, borderRadius: 10,
                border: "1px solid " + t.borderStrong,
                background: t.surface,
                display: "flex", alignItems: "center", justifyContent: "center",
                color: t.textMid, textDecoration: "none",
                fontFamily: "'DM Mono', monospace",
                fontSize: s.icon === "in" ? 11 : 14,
                fontWeight: s.icon === "in" ? 700 : 400,
              }}
              title={s.name}
            >{s.icon}</a>
          ))}
        </div>
      </div>
    </div>
  );
}
